<template lang="pug">
app-page-layout(fix-header)
  app-table-page-layout
    template(#toolbar-left)  
      app-search(
        v-model="filters"
        :fields="filterFieleds"
        keywordPlaceholder="姓名/账号"
      )
      a-button.ml2(@click="$refs.table.reload()") 刷新      
    //- template(#toolbar-right)    
      a-button(type="primary" @click="handleExport" :loading="exportLoading") 导出数据    
    app-table(
      ref='table',
      model-name='User',
      url='/sys/users/page',
      :selectionMode='false',
      :params='params',
      :visibles='columns',
      :columns-customsize='columnsCustomsize'
      :fitHeight="20"
    )
      template(#action='{record}')
        app-action-column
          app-link-btn-delete(@confirm='(cb) => handleDelete(record, cb)') 删除用户
</template>
<script>
import { GETTER_PROJECT } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      columns: [
        'username',
        'nickname',
        'mobile',
        'gender',
        // 'isOwner',
        // 'companyName',
        // 'storeName',
        'createTime',
      ],
      search: null,
      isCompanyOwner: '',
      filters: {},
      filterFieleds: [],
      typeList: [
        {
          value: '档主',
          key: 'true',
        },
        {
          value: '从业人员',
          key: 'false',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
    }),
    params() {
      return {
        ...this.filters,
        projectId: this.project.id,
        type: 'userType_store',
      };
    },
  },
  created() {
    this.initFilters();
  },
  methods: {
    columnsCustomsize(columns, config) {
      columns.push({
        uid: 'action',
        dataIndex: 'action',
        title: '操作',
        width: '13rem',
        fixed: config.fixedActionColumn ? 'right' : null,
      });
      return columns;
    },
    onChange() {},
    // 删除
    async handleDelete(record, cb) {
      // console.log(record, 'record');
      // await this.$restful(`delete:/sys/users/${record.id}`);
      await this.$restful(`DELETE:/prj/vendor-user-mappings`, {
        // vendorId: this.target.id,
        userId: record.id,
        remove: true,
      });
      cb();
      this.$message.success('删除成功!');
      this.$refs.table.reload();
    },
    searchClick() {
      this.search = this.searchForm.search;
      this.isCompanyOwner = this.searchForm.isCompanyOwner;
      this.searchStore = this.searchForm.searchStore;
      this.areaId = this.searchForm.areaId;
    },
    // 初始化筛选条件
    initFilters() {
      this.filterFieleds = [
        // {
        //   name: 'vendorId',
        //   component: 'app-remote-select',
        //   width: '150px',
        //   placeholder: '商家',
        //   api: '/prj/vendors/list',
        //   params: { projectId: this.project.id },
        //   showSearch: true,
        // },
      ];
    },
  },
};
</script>
<style lang="less" scoped>
.user_container {
  padding: 20px;

  .user_search {
    margin-bottom: 10px;
  }
}
</style>
